import styled, { css } from 'styled-components';

import { Card, mediaBreakpointMixin, mediaMixin, spaceMixin, token } from '@zillow/constellation';

export const StyledHeadingLink = styled.span`
  ${mediaMixin(
    'sm',
    css`
      float: right;
    `,
  )}
`;

export const StyledContainer = styled.div`
  margin-top: 8px;

  ${mediaMixin(
    'md',
    css`
      margin-top: 0px;
    `,
  )}
`;

export const StyledBlueCard = styled(Card)`
  background-color: ${token('colors.blue100')};
  padding-left: ${spaceMixin('xl')};
  padding-right: ${spaceMixin('xl')};

  @media ${mediaBreakpointMixin('sm_lte')} {
    padding-left: ${spaceMixin('sm')};
    padding-right: ${spaceMixin('sm')};
  }
`;
